import { DecimalPipe } from "@angular/common";
import { Directive, ElementRef, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { NgControl } from "@angular/forms";

export enum Language {
  es = "es"
}

let language = Language.es;

@Directive({
    selector: '[appSpanishNumber]',
    host: { '(blur)': 'setNewValue()', '(keydown)': 'inputChanges()' },
    standalone: false
})
export class SpanishNumberDirective implements OnInit {
  inputChange = false;
  initialValue = '';
  constructor(
    public _el: ElementRef,
    private control: NgControl,
    private dp: DecimalPipe
  ) { }

  inputChanges() {
    this.inputChange = true;
  }
  ngOnInit(): void {    
    if (this.control.value !== null) {
      this.setInputValue();
      this.control.valueChanges.subscribe(res => {        
        if (this.inputChange == false) {
          this.setInputValue();
        }
      });
    }
  }

  private setInputValue() {
    if (language == Language.es) {
      if (this.initialValue === this._el.nativeElement.value) return
      let _str = this._el.nativeElement.value.toString().split('.');
      if (_str.length > 2) {
       // this._el.nativeElement.style.border = '1px solid red';
        this.control.control.setErrors( {hasTwoDecimalPlaces : true})
      } else {
        this.control.control.setErrors( {hasTwoDecimalPlaces : false})
        _str.length === 2 ? _str : _str.push('0');
        this.control.control.setValue(this.formatNumber(_str));
        this.initialValue = this._el.nativeElement.value
      }
    }
  }

  setNewValue() {
    if (this.control.value !== null) {
      if (language == Language.es) {
        if (this.initialValue === this._el.nativeElement.value) return
        let _str = this._el.nativeElement.value.toString().split(',');
        if (_str.length > 2) {
          this.control.control.setErrors( {hasTwoDecimalPlaces : true})
        } else {
          try {
            this.control.control.setErrors( {hasTwoDecimalPlaces : false})
            _str.length === 2 ? _str : _str.push('0');
            this.control.control.setValue(this.formatNumber(_str));
            this.initialValue = this._el.nativeElement.value
          } catch (error) {
            this.control.control.setErrors( {hasTwoDecimalPlaces : true})
          }
        }
      }
      this.inputChange = false;
    }
  }

  // If the values is correct, 0th index is the number 1st index is decimal point value
  /**
   * 
   * Need to verify the functionality if the language change
   * this directive breaks if we use another language(code written inside try)
   */
  formatNumber(number: any[]) {
    if (language == Language.es) {
      if (number.length == 2) {
        let actualValue =
          number[0].replace(/\./g, '').replace(/,/g, '') + '.' + number[1];
        var engFormat = '';
        try {
          engFormat = this.dp.transform(actualValue, '1.0-2', 'en-US');
        } catch (ex) {
          engFormat = actualValue;
          return engFormat;
        }
        var _eng = engFormat.split('.');
        return _eng.length == 2
          ? _eng[0].replace(/,/g, '.') + ',' + (_eng[1].length == 2 ? _eng[1] : _eng[1] + "0" )
          : _eng[0].replace(/,/g, '.') + ',00';
      }
    }
  }
}